export enum ResourceTypes {
  FULFILMENT_CENTER = 1,
  DISTRIBUTION_CENTER = 2,
  COLLECTION_CENTRE = 3,
  COLLECTION_ZONE = 4,
}
export enum Roles {
  LOGISTICS_OPERATOR = 9,
  FULFILLMENT_OPERATOR = 8,
  FULFILLMENT_MANAGER = 5,
}

export enum BulkUploadResultKey {
  RESULT_FILE_URL = 'result_file_url',
  ERROR_FILE_URL = 'error_file_url',
}
